import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { LocaStockService } from '../../../service/loca-stock/loca-stock.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';

@Component({
  selector: 'app-root',
  templateUrl: 'wa6013.component.html',
  styleUrls: ['wa6013.component.css']
})
export class Wa6013Component implements OnInit {
  public componentTitle = 'WA6013:在庫備考修正';

  public locaStock: object[];
  public ownerId: number;
  public notapplyFl: number;
  public memoTx = new FormControl('', [Validators.maxLength(50)]);

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  constructor(private router: Router, private locaStockService: LocaStockService, private commonService: CommonService, private dialogsService: DialogsService) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit(): void {
    this.locaStock = JSON.parse(sessionStorage.getItem('wa6013SelectIds'));
    this.ownerId = Number(sessionStorage.getItem('ownerId'));
  }

  execute() {
    this.working = true;
    if (!this.notapplyFl) {
      this.working = false;
      this.errorInfo = '出荷引当を選択してください';
      return;
    }
    if (this.memoTx.value && this.memoTx.value.length > 50) {
      this.working = false;
      this.errorInfo = '備考は50文字以下で入力してください';
      return;
    }
    this.locaStockService
      .updStockMemo(this.locaStock, this.ownerId, this.notapplyFl, this.memoTx.value, 'wa6013')
      .then(outputJson => {
        sessionStorage.removeItem('wa6013SelectIds');
        sessionStorage.removeItem('ownerId');
        this.working = false;
        this.router.navigate(['wa6010']);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.router.navigate(['wa6010']);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa6Stock/wa6013/wa6013.component.ts